export type ColumnId =
  | 'ServiceItem'
  | 'Global'
  | 'Hidden'
  | 'LastUpdatedBy'
  | 'ServiceType'
  | 'Version'
  | 'VersionCreated'
  | 'Courtesy'
  | 'PriceType'
  | 'SupportingItems'
  | 'Price'
  | 'ProPrice'
  | 'Actions'

export interface InventoryColumnDetails {
  id: ColumnId
  header: string
  align: 'left' | 'right' | 'center'
}

export const InventoryTableColumns: InventoryColumnDetails[] = [
  {
    id: 'ServiceItem',
    header: 'Service Item',
    align: 'left',
  },
  {
    id: 'Global',
    header: 'Global',
    align: 'center',
  },
  {
    id: 'Hidden',
    header: 'Hidden',
    align: 'center',
  },
  {
    id: 'LastUpdatedBy',
    header: 'Last updated by',
    align: 'left',
  },
  {
    id: 'ServiceType',
    header: 'Service type',
    align: 'left',
  },
  {
    id: 'Version',
    header: 'Version',
    align: 'center',
  },
  {
    id: 'VersionCreated',
    header: 'Version created',
    align: 'left',
  },
  {
    id: 'Courtesy',
    header: 'Courtesy',
    align: 'center',
  },
  {
    id: 'PriceType',
    header: 'Price type',
    align: 'left',
  },
  {
    id: 'SupportingItems',
    header: 'Supporting Items',
    align: 'center',
  },
  {
    id: 'Price',
    header: 'Price',
    align: 'right',
  },
  {
    id: 'ProPrice',
    header: 'Pro price',
    align: 'right',
  },
  {
    id: 'Actions',
    header: '',
    align: 'right',
  },
]
